// Master admin access. Hardcoded master account + optional VITE_ADMIN_EMAILS list.
export const MASTER_ADMIN_EMAIL = "skdaks0731@gmail.com";

const extraAdminEmails = (import.meta.env.VITE_ADMIN_EMAILS || "")
  .split(",")
  .map((v) => v.trim().toLowerCase())
  .filter(Boolean);

export const ADMIN_EMAILS = Array.from(
  new Set([MASTER_ADMIN_EMAIL.toLowerCase(), ...extraAdminEmails])
);

export const isAdminEmail = (email?: string | null): boolean => {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase());
};
